<app-exercise [points]="points" [isResultPublished]="isResultPublished" [correctAnswers]="correctAnswers"
  [courseFeedback]="courseFeedback" [courseId]="courseId" [courseTitle]="courseTitle" [answers]="answers"
  [isSubmitted]="true" [taFeedbacks]="taFeedbacks" [variableFeedback]="variableFeedback" [exerciseData]="exerciseData">
</app-exercise>